import { apiGet, apiPost, apiPut, apiPutMultipart } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import isEmpty from 'lodash/isEmpty';

import * as notifications from './notificationActions';
import { dispatchPayloadAction } from './simpleActions';

export function getLandlordTrafficSources(property_id = null) {
  let route = '/landlords/traffic_sources';
  if (property_id) {
    route = `/landlords/properties/${property_id}/traffic_sources`;
  }
  return (dispatch) => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + route)
        .done((response) => {
          dispatch(landlordTrafficSources(response));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}

export function landlordTrafficSources(trafficSources) {
  if (isEmpty(trafficSources) || !Array.isArray(trafficSources)) {
    trafficSources = [];
  }
  return {
    type: 'TRAFFIC_SOURCES',
    trafficSources,
  };
}

export function displayLeads(response) {
  return {
    type: 'SHOW_LEADS',
    leads: response,
  };
}

export function postLead(data, landlord_id) {
  let route = '/landlords/leads';
  let data_clone = JSON.parse(JSON.stringify(data)); // needed so it does not change redux form data
  if (data_clone['property']) {
    data_clone['property'] = data_clone['property']['value'];
  }
  if (!Array.isArray(data_clone['desired_unit'])) {
    data_clone['desired_unit'] = [data_clone['desired_unit']];
  }
  if (landlord_id) {
    route = `/landlords/lead/${landlord_id}`;
  }
  data_clone['birthday'] = data_clone['dob'];

  return (dispatch) => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + route, data_clone)
        .done((response) => {
          dispatch(notifications.showSuccess('successfullyAddedProspect'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function putLead(lead_id, formData) {
  return (dispatch) => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/leads/${lead_id}`, formData)
        .done((response) => {
          dispatch(notifications.showSuccess('leadSuccessfullyUpdated'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function getReferrals() {
  return dispatchPayloadAction(
    () => apiGet(Auth.getApiUrl() + '/landlords/referrals'),
    (dispatch, response) =>
      dispatch({
        type: 'DISPLAY_REFERRALS',
        referrals: response.referrals,
      })
  );
}

export function updateReferral(leadCardId, isComplete) {
  return (dispatch) => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/referrals/${leadCardId}`, {
        is_complete: isComplete,
      })
        .done((response) => {
          return dispatch(notifications.showSuccess('successfullyClosedReferral'));
        })
        .catch((error) => {
          dispatch(notifications.showFailure(error));
        }),
    });
  };
}

export function getLeadByEmail(email, options = { exclude_id: '' }) {
  if (!email) {
    email = '';
  }
  const encodedEmail = encodeURIComponent(email).replace(/\./g, '%2E');
  return (dispatch) => {
    return dispatch({
      payload: apiGet(
        Auth.getApiUrl() +
          `/landlords/leads/find_by_email?email=${encodedEmail}&&exclude_id=${options.exclude_id}`
      )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return null;
        }),
    });
  };
}

export function uploadLeadDocuments(documentData, cotenant_id) {
  const multiPartFormData = new FormData();

  if (documentData['proofOfId']) {
    multiPartFormData.append('id_proof_type', documentData['idProofType']);
    multiPartFormData.append('proof_of_id', documentData['proofOfId'][0]);
  }

  if (documentData['proofOfIncome']) {
    multiPartFormData.append('income_proof_type', documentData['incomeProofType']);
    multiPartFormData.append('proof_of_income', documentData['proofOfIncome'][0]);
  }

  return async (dispatch) => {
    if (!documentData['proofOfId'] && !documentData['proofOfIncome']) return;
    return dispatch({
      payload: apiPutMultipart(
        Auth.getApiUrl() + `/landlords/tenants/${cotenant_id}/upload_docs`,
        multiPartFormData
      )
        .done(() => {
          dispatch(notifications.showSuccess('successfullyUploadedDocument'));
        })
        .catch((error, textStatus) => {
          console.error(textStatus);
        }),
    });
  };
}
